// Where an access code sends the customer.
//
// ONE decision, in one place, because it is a rule about the BUSINESS and not about
// this form: an access code belongs to one shoot, and which screen it opens depends on
// whether that shoot is this year's.
//
//   yearbook order ............. the yearbook flow, regardless of season
//   prior-year SENIOR code ..... THIS year's senior pricelist -- a senior who ordered
//                                last year wants this year's offering, not a grid of
//                                old portraits
//   any other prior-year code .. the past-images screen
//   current-year code .......... that season's packages
//
// `pastSeason` and `seniorPastPackageId` are decided SERVER-side against SeasonCalendar
// (seniors roll June 1, everything else July 1) — see StudentImage#past_season?. Nothing
// here does year arithmetic, so the rollover rule lives in exactly one place.
//
// The prior-year branch beats `packageId` on purpose. A school that still has last
// year's pricelist visible (Central Valley lists 661 "EL Fall Portraits" for fall2026)
// otherwise sent the customer into last year's packages — and its 50%-OFF Buy All —
// instead of past images.

export const YEARBOOK = 'yearbook';
export const PAST_IMAGES = 'past_images';
export const PACKAGES = 'packages';

export default function accessCodeDestination({
  isYearbookOrder = false,
  pastSeason = false,
  seniorPastPackageId = null,
  packageId = null,
  season = '',
} = {}) {
  if (isYearbookOrder) return { kind: YEARBOOK };

  // Seniors only, and only when the school actually has a current senior pricelist to
  // send them to. Without one there is nothing to show, so they fall through to past
  // images like everyone else rather than landing on an empty package list.
  if (pastSeason && seniorPastPackageId) {
    return { kind: PACKAGES, packageId: seniorPastPackageId, senior: true };
  }

  if (pastSeason || !packageId) return { kind: PAST_IMAGES };

  return {
    kind: PACKAGES,
    packageId,
    senior: String(season).toLowerCase().includes('senior'),
  };
}
